import { FieldError } from "../../error";
import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { isValidUKBusinessNumber } from "../../validate";
export class CompanyNumberField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "12345678",
      propertyName: "companyNumber",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;
    if (
      registeredCountry === "United Kingdom" &&
      (businessType === "Private Company" ||
        businessType === "Public Limited Company")
    ) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    const value = this.value ?? "";
    if (!isValidUKBusinessNumber(value)) {
      throw new FieldError(
        this,
        `UK registered company numbers have 8 characters - either 8 numbers (12345678) or 2 letters + 6 numbers (AB123456). If you only have seven numbers, add a leading zero (01234567).`,
        "InvalidCompanyNumber"
      );
    }
  }
}
